import React, { useRef, useState } from "react";
import { Container, Grid, useTheme } from "@mui/material";

import { P, SectionHeading, SectionSmallHeading, SectionSubHeading, SectionWrapper } from "../../Styles/style";
import roadmapimg from  '../../../assets/images/roadmapimg.png'

import secbg from "../../../assets/images/secbg.png"
import tokenimage from "../../../assets/images/tpeknimg.png"
import { MainGrid } from "./styles";
import styled from "@emotion/styled";

const SectionSubWrapper = styled.div`
position: relative;
z-index:1;
  background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.bgPrimary)};
  padding: ${(props) => (props.p ? props.p : "4rem 0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  text-align: ${(props) => (props.align ? props.align : "-webkit-center;")};
  text-align: ${(props) => (props.align ? props.align : "-moz-center;")};
border-top:${(props) => (props.bt ? props.bt : "")};
  @media screen and (max-width: 799px) {
    padding: ${(props) => (props.p799 ? props.p799 : "30px 0")};
  }
  @media screen and (max-width: 599px) {
    padding: ${(props) => (props.p599 ? props.p599 : "30px 0")};
  }
`;

const MainWrapper = styled.div`
display:flex;
align-items: center;
justify-content:center;

text-align: -webkit-center;
text-align: -moz-center;
/* min-height: 100vh; */
padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  text-align: ${(props) => (props.align ? props.align : "center")};

  @media screen and (max-width: 799px) {
    padding: ${(props) => (props.p799 ? props.p799 : "")};
  }
  @media screen and (max-width: 599px) {
    padding: ${(props) => (props.p599 ? props.p599 : "30px 0")};
  }
`

const BuyNow = styled.a`
text-decoration: none;
background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.textTertiary)};
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
padding: 8px 50px;
border-radius: 5px;
margin-right: 15px;

`

const Img = styled.img`
  width:100%;
  max-width: 300px;
  position: absolute;
    bottom: -0;
    right: 0;
`
const Tokenimg = styled.img`
  width:100%;
  max-width: 450px;
  height:auto;
  position:absolute;
  top: -12px;
  @media screen and (max-width: 1499px) {
    top: 12px;
  }
  @media screen and (max-width: 1199px) {
    top: 43px;
  }
  @media screen and (max-width: 899px) {
      position:unset;
  }
`
const GridsWrap = styled(Grid)`
/* position:relative; */
text-align:left;
`
const Grids = styled(Grid)`
/* display:flex;
align-items:center;
flex-direction:column; */
`
const Containers = styled(Container)`
  position: relative;
`
const WrapperRoad = styled.div`
  border-radius:20px;
  background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.bgPrimary)};
  padding:20px 50px;
  box-shadow: 7px 11px 1px 1px #4A4E5C;
  min-height:450px;
  @media screen and (max-width: 1199px) {
    min-height:520px;
  }
`
const Index = () => {
  const theme = useTheme()


  return (
    <div>


      <MainWrapper p="4rem 0" align="center" id="tokenomics" style={{position:'relative'}}  >
        <Container maxWidth="xl">
          <SectionSmallHeading fs="60px" fs599="40px" p="20px 0px 0" m="0" data-aos="flip-down"
            data-aos-easing="ease-in"
            data-aos-delay="500"
            data-aos-duration="700"
            align="center"
            data-aos-offset="0">Roadmap</SectionSmallHeading>
          <P p="0px 0px 30PX"align="center" color={theme.textSecondary}>The goal of Mini-Pepe's roadmap is to establish the cryptocurrency as a valuable and <br />influential asset in the market with a focus on community building. The team has <br />planned plenty of surprises along the way as they work towards their ultimate goal of <br />becoming a sensation in the crypto space.</P>
          <Grid container justifyContent="center" spacing={3} >
            <Grid item xs={12} md={3}>
              <WrapperRoad>
                <SectionSubHeading>Phase 1</SectionSubHeading>
                <P d="list-item">Launch</P>
                <P d="list-item">Coingecko/</P>
                <P d="list-item">  Coinmarketcap Listings</P>
                <P d="list-item">Marketing Push To Ge</P>
                <P d="list-item">$PEPE Trending</P>
                <P d="list-item">1,000+ Holders</P>
              </WrapperRoad>
            </Grid>
            <Grid item xs={12} md={3}>
              <WrapperRoad>
                <SectionSubHeading>Phase 2</SectionSubHeading>



                <P d="list-item">Community Partnerships </P>
                <P d="list-item">Private Top Holders </P>
                <P d="list-item">Channel </P>
                <P d="list-item">
                  Centralized Exchange
                </P>
                <P d="list-item">Listings</P>
                <P d="list-item">
                  10,000+ Holders</P>
              </WrapperRoad>
            </Grid>
            <Grid item xs={12} md={3}>
              <WrapperRoad>
                <SectionSubHeading>Phase 3</SectionSubHeading>


                <P d="list-item">Mini Pepe NFT</P>
                <P d="list-item"> Collection</P>
                <P d="list-item">
                  T1 Exchange Listings</P>
                <P d="list-item">100,000+ Holders</P>
              </WrapperRoad>
            </Grid>


          </Grid>
          <Img src={roadmapimg}/>
        </Container>
      </MainWrapper>
      {/* ///////////////////////////////////////////////////////// */}
      <SectionSubWrapper p799="8rem 0 0" p599="4rem 0 0" p="9.8rem 0">
        <Container maxWidth="xl">

          <MainGrid container spacing={0}>
            <GridsWrap item xs={12} md={6} data-aos="flip-down"
              data-aos-easing="ease-in"
              data-aos-delay="500"
              data-aos-duration="700"
              data-aos-offset="0">
              <Tokenimg src={tokenimage} />

            </GridsWrap>
            <Grids item xs={12} md={6} data-aos="fade-up"
              data-aos-anchor-placement="top-bottom" data-aos-delay="600"
              data-aos-duration="1000">
              <SectionSubHeading align="right" fs="40px" p=" 30px 0 0">
                About Us
              </SectionSubHeading>
              <P align="right">MiniPepe's team aims to establish the cryptocurrency as a fun and engaging investment option with its unique Pepe the Frog meme-based branding, while also exploring potential real-world applications for the coin.</P>
            </Grids>

          </MainGrid>

        </Container>
      </SectionSubWrapper>
    </div>
  );
};

export default Index;
